<template>
  <div>
    <div class="header">
      <div class="w1200">
        <div class="clearfix">
          <img class="fl"
               src="../../assets/img/logo.png"
               alt="">
          <ul class="fl nav">
            <li @click="$router.push('/')">
              <div>
                <p><span :class="$route.path == '/' ? 'text on':'text'">个人介绍</span></p>
              </div>
            </li>
            <li>
              <div>
                <p><span :class="$route.path == '/haiplus' || $route.path == '/shiguangshu' || $route.path == '/h5' ? 'text on':'text'">界面设计</span></p>
                <ul>
                  <li @click="$router.push('/shiguangshu')">
                    <span class="color2">拾光书APP</span>
                  </li>
                  <li @click="$router.push('/haiplus')">
                    <span class="color1">HAIPLUS</span>
                  </li>
                  <!-- <li>
                    <span class="color3">BANNER</span>
                  </li> -->
                  <li @click="$router.push('/h5')">
                    <span class="color4">活动H5</span>
                  </li>
                </ul>
              </div>
            </li>
            <li>
              <div>
                <p><span :class="$route.path == '/shiguangshuweb' ? 'text on':'text'"
                        @click="$router.push('/shiguangshuweb')">web设计</span></p>
                <!-- <ul>
                  <li @click="$router.push('/shiguangshuweb')">
                    <span class="color5">拾光书官网</span>
                  </li>
                  <li>
                    <span class="color6">电商页面</span>
                  </li>
                </ul> -->
              </div>
            </li>
            <li>
              <div>
                <p><span :class="$route.path == '/hongpa' || $route.path == '/book' || $route.path == '/logo' ? 'text on':'text'">平面设计</span></p>
                <ul>
                  <li @click="$router.push('/hongpa')">
                    <span class="color8">玩转轰趴</span>
                  </li>
                  <li @click="$router.push('/book')">
                    <span class="color9">书籍装帧</span>
                  </li>
                  <li @click="$router.push('/logo')">
                    <span class="color7">LOGO设计</span>
                  </li>
                </ul>
              </div>
            </li>
            <li @click="$router.push('/chahua')">
              <div>
                <p><span :class="$route.path == '/chahua' ? 'text on':'text'">插画</span></p>
              </div>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Head',
  created () {
    console.log(this.$route.path)
  }
}
</script>
<style lang="scss" scoped>
.header {
  position: fixed;
  left: 0;
  top: 0;
  width: 100%;
  background: #121212;
  height: 70px;
  vertical-align: middle;
  color: #999;
  font-size: 15px;
  img {
    margin-top: 11px;
    margin-top: 22px;
    width: 20px;
    height: auto;
  }
}
.nav > li {
  float: left;
  padding: 0 30px;
  position: relative;
  ul {
    height: 0;
    opacity: 0;
    overflow: hidden;
    width: 100%;
    position: absolute;
    left: 0;
    top: 60px;
    text-align: center;
    transition: all 0.3s;
    z-index: 99;
    li {
      line-height: 50px;
      background: #121212;
      cursor: pointer;
      span {
        display: inline-block;
        width: 90px;
        padding: 2px 10px;
        border-radius: 5px;
        line-height: 22px;
        transition: all 0.3s;
        font-size: 14px;
      }
      &:hover {
        color: #fff;
        span.color1 {
          background: #a344b8;
        }
        span.color2 {
          background: #612ef2;
        }
        span.color3 {
          background: #fc5800;
        }
        span.color4 {
          background: #8fc31f;
        }
        span.color5 {
          background: #32c3d3;
        }
        span.color6 {
          background: #a4005b;
        }
        span.color7 {
          background: #0031ae;
        }
        span.color8 {
          background: #e94960;
        }
        span.color9 {
          background: #910800;
        }
      }
    }
  }
  p {
    line-height: 70px;
    font-size: 15px;
    cursor: pointer;
  }
  span.text{
    transition: all 0.3s;
    &.on{
      color: #fff;
      border-bottom: 1px solid #fff;
      padding-bottom: 5px;
    }
  }
  &:hover {
    span.text {
      padding-bottom: 5px;
      color: #fff;
      border-bottom: 1px solid #fff;
    }
  }
  &:hover {
    ul {
      height: auto;
      opacity: 1;
      overflow: visible;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/view/LayOut/heads.vue